import moment from "moment";

export const parseDateToString = (date, language = "th-TH", options = {}) => {
  if (date === undefined || date === null) return date;

  let newDate = date;
  const defaultOptions = {
    year: "numeric",
    month: "2-digit",
    day: "2-digit",
  };

  if (typeof date == "string") {
    newDate = new Date(date);
  }
  return newDate.toLocaleDateString(language, {
    ...defaultOptions,
    ...options,
  });
};

export const parseToMoment = (date) => {
  if (date === undefined || date === null) return date;

  let newDate = date;
  if (typeof date == "string") {
    newDate = new Date(date);
  }

  return moment(newDate);
};

export const msToTime = (ms) => {
  let seconds = (ms / 1000).toFixed(0);
  let minutes = (ms / (1000 * 60)).toFixed(0);
  let hours = (ms / (1000 * 60 * 60)).toFixed(0);
  let days = (ms / (1000 * 60 * 60 * 24)).toFixed(0);
  let prefix = "ใช้ได้อีก ";
  if (seconds < 60) return prefix + seconds + " วินาที";
  else if (minutes < 60) return prefix + minutes + " นาที";
  else if (hours < 24) return prefix + hours + " ชม.";
  else return prefix + days + " วัน";
};
